import api from '../services/api';

export const getProcurementSettings = async () => {
  try {
    const response = await api.get('/api/procurement/settings');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching procurement settings:', error);
    throw error;
  }
};

export const updateProcurementSettings = async (settings) => {
  try {
    const response = await api.put('/api/procurement/settings', settings);
    return response.data.data;
  } catch (error) {
    console.error('Error updating procurement settings:', error);
    throw error;
  }
};

export const getProcurement = async (params = {}) => {
  try {
    const response = await api.get('/api/procurement', { params });
    return response.data.data;
  } catch (error) {
    console.error('Error fetching procurement:', error);
    throw error;
  }
};

export const createProcurement = async (procurementData) => {
  try {
    const response = await api.post('/api/procurement', procurementData);
    return response.data.data;
  } catch (error) {
    console.error('Error creating procurement:', error);
    throw error;
  }
};

export const updateProcurement = async (id, procurementData) => {
  try {
    const response = await api.put(`/api/procurement/${id}`, procurementData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating procurement:', error);
    throw error;
  }
};

export const deleteProcurement = async (id) => {
  try {
    const response = await api.delete(`/api/procurement/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error deleting procurement:', error);
    throw error;
  }
};

export const getProcurementCategories = async () => {
  try {
    const response = await api.get('/api/procurement/categories');
    return response.data.data;
  } catch (error) {
    console.error('Error fetching procurement categories:', error);
    throw error;
  }
};

export const submitQuote = async (id, quoteData) => {
  try {
    const response = await api.post(`/api/procurement/submit/${id}`, quoteData);
    return response.data.data;
  } catch (error) {
    console.error('Error submitting quote:', error);
    throw error;
  }
};

export const confirmProcurement = async (id, confirmationData) => {
  try {
    const response = await api.post(`/api/procurement/confirm/${id}`, confirmationData);
    return response.data.data;
  } catch (error) {
    console.error('Error confirming procurement:', error);
    throw error;
  }
};

export const extendProcurement = async (id, extensionData) => {
  try {
    const response = await api.post(`/api/procurement/extend/${id}`, extensionData);
    return response.data.data;
  } catch (error) {
    console.error('Error extending procurement:', error);
    throw error;
  }
};

export const importProcurement = async (fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const response = await api.post('/api/procurement/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data.data;
  } catch (error) {
    console.error('Error importing procurement:', error);
    throw error;
  }
};

export const getSupplierApplications = async (params = {}) => {
  try {
 
    const response = await api.get('/api/procurement/supplier_applications', { params });
 
    return response.data.data;
  } catch (error) {
    console.error('Error fetching supplier applications:', error);
    throw error;
  }
};

export const getNewSupplier = async (id) => {
  try {
    const response = await api.get(`/api/procurement/new_supplier/${id}`);
    return response.data.data;
  } catch (error) {
    console.error('Error fetching new supplier:', error);
    throw error;
  }
};

export const updateSupplierContact = async (bpCode, contactData) => {
  try {
    const response = await api.put(`/api/procurement/suppliers/${bpCode}`, contactData);
    return response.data.data;
  } catch (error) {
    console.error('Error updating supplier contact:', error);
    throw error;
  }
};

export const activateSupplier = async (supplierData) => {
  try {
    const response = await api.post('/api/procurement/activate_supplier', supplierData);
    return response.data.data;
  } catch (error) {
    console.error('Error activating supplier:', error);
    throw error;
  }
};

export const supplierApplicationAction = async (actionData) => {
  try {
    const response = await api.post('/api/procurement/application_action', actionData);
    return response.data.data;
  } catch (error) {
    console.error('Error performing supplier application action:', error);
    throw error;
  }
};

export const unrejectSupplierApplication = async (reference) => {
  try {
    const response = await api.post('/api/procurement/unreject_application', { reference });
    return response.data.data;
  } catch (error) {
    console.error('Error unrejecting supplier application:', error);
    throw error;
  }
};

export const deleteSupplierApplication = async (reference) => {
  try {
    const response = await api.post('/api/procurement/delete_application', { 
      reference 
    });
    return response.data.data;
  } catch (error) {
    console.error('Error deleting supplier application:', error);
    throw error;
  }
};

export const getSupplierGroups = async (params = {}) => {
  try {
    const response = await api.get('/api/suppliers/groups', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching supplier groups:', error);
    throw error;
  }
};
